export default __webpack_public_path__ + "static/media/008-bunny.e8eb0cb1.svg";